// extracted by mini-css-extract-plugin
export default {"onBoardingContainer":"styles_onBoardingContainer__XbDcD","middle":"styles_middle__XrMxF","greyBackground":"styles_greyBackground__Qdkqn"};